<div class="icon-wrapper">
   <mat-icon>warning</mat-icon>
</div>
<h1 class="access-denied-header">Access Denied</h1>
<p class="access-denied-message">You do not have access to this page.</p>
